import React from 'react'
import { FaRegTimesCircle } from "react-icons/fa";
import './DeletePopup.scss'

const DeletePopup = ({ isOpen, onClose, onConfirm, message, title, t }) => {

    if (!isOpen) return null;

    return (
        <div className='overlay'>
            <div className='delete-popup'>
                <div className='delete-title'>
                    <span>{title}</span>
                    <FaRegTimesCircle className='cut-icon' onClick={onClose}/>
                </div>
                <div className='message-button-flex'>
                    <p>{message}</p>
                    <div className='buttons'>
                        <button className='cancelButton' onClick={onClose}>
                            {t('common.cancel')}
                        </button>
                        <button className='deleteButton' onClick={onConfirm}>
                            {t('common.delete')}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DeletePopup